import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  DateRangPickerField,
} from "../../../../_metronic/_partials/controls";
import { Button, Accordion } from "react-bootstrap";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import moment from "moment";
import DeleteDialog from "../../../components/DeleteDialog";
import * as actions from "./_redux/CompanyActions";
import { columns } from "./columns";
import * as UIHelpers from "../../../components/UIHelpers";
import DataTable from "../../../components/DataTable";
import CountryListDropdown from "../../../components/CountryListDropdown";
import { useParams, useHistory } from "react-router-dom";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";
import DateRangeFilterComponent from "../../../components/DateRangeFilterComponent";

export const initialFilter = {
  sort: "desc", // asc||desc
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
  filter: {},
  // dateRange: { from: moment().toDate(), to: moment().toDate() }, //{from: moment().toDate(), to: moment().toDate()}
};

export default function CompanyPackages(props) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Company");

  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.AddCompany }),
    shallowEqual
  );

  const {
    entities,
    totalCount,
    listLoading,
    exportData,
    uploadimage,
    imageField,
    newCoinCategory,
    editCompany,
    deletedCompany,
  } = currentState;

  const history = useHistory();
  const [
    countrySelectedDropdownFilterData,
    setCountryListDropdownFilterData,
  ] = useState(null);
  const [fileData, setFileData] = useState(undefined);
  const [formInputValues, setFormInputValues] = useState({
    _id: undefined,

    name: "",
    description: "",
    order: 0,
    img: "",
    isActive: true,
  });

  const [filter, setFilter] = useState(initialFilter);
  const [dateRange, setDateRange] = useState({
    from: moment(new Date()),
    to: moment(new Date()),
  });

  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns);
  const [cols, setCols] = useState(columns);

  const [searchApply, setSearchApply] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEditItem, setIsEditItem] = useState(false);

  const addItem = () => {
    history.push("/company-Addform");
  };
  const settingItem = (row_value) => {
    history.push(`/company-gameAddform/${row_value?._id}`);
  };
  useEffect(() => {
    let temp = [...columns];
    setCols(temp);
    let data = {};
    data.pagination = {};
    data.pagination.pageNo = 1;
    data.pagination.sortBy = "createdAt";
    dispatch(actions.fetchCompanyList(data));
  }, [isEditItem]);

  useEffect(() => {
    console.log("entities: ", entities);
    if (entities) {
      setRows(entities);
    } else {
      setRows([]);
    }
  }, [entities]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  // Function to handle delete item click
  // Function to initiate delete action
  const initiateDelete = (row_value) => {
    console.log("row_value: ", row_value);
    dispatch(actions.deleteCompany(row_value?._id));
  };

  // Function to handle delete item click
  const handleDeleteItemClick = (row_value) => {
    setItemToDelete(row_value);
    setShowDeleteDialog(true);
  };

  // Function to handle delete confirmation
  const handleDeleteConfirmation = () => {
    // Perform deletion action here
    if (itemToDelete) {
      initiateDelete(itemToDelete);
    }
    // Close the delete dialog
    setShowDeleteDialog(false);
  };

  const companyCountryRedirect = (row_value) => {
    localStorage.setItem("selectedCountryName",row_value?.name)
    history.push(`/countries-frontend/list/${row_value?.code}`);
  };

  useEffect(() => {
    let temp1 = [];
    allColumns.map((item, index) => {
      if (item?.show === true) {
        temp1.push(item);
      }
    });
    temp1.push(
      {
        dataField: "isActive",
        text: "isActive",
        sort: false,
        show: true,
        format: {
          type: "isActive",
          formatfunction: {
            // onChangeIsActive: onChangeIsActive,
            onChangeIsActive: helperFunc.isButtonAccess(
              "company.company.update"
            )
              ? onChangeIsActive
              : null,
          },
        },
      },
      {
        dataField: "action",
        text: "Actions",
        sort: false,
        show: true,
        format: {
          type: "action",
          style: {
            width: "150px",
          },
          formatfunction: {
            editItem: helperFunc.isButtonAccess("company.company.update")
              ? editItem
              : null,
            settingItem: helperFunc.isButtonAccess("company.company.update")
              ? settingItem
              : null,
            deleteItem: helperFunc.isButtonAccess("company.company.delete")
              ? handleDeleteItemClick
              : null,
            companyCountryRedirect: companyCountryRedirect
          },
        },
      }
    );
    setAllColumns(temp1);
  }, [columns]);

  useEffect(() => {
    console.log("exportData: ", exportData);
    if (
      exportData &&
      exportData?.success &&
      exportData?.item &&
      exportData?.item?.fileName
    ) {
      window.open(
        `${UIHelpers.exportUrl}${exportData?.item?.fileName}`,
        "_blank"
      );
    }
  }, [exportData]);

  useEffect(() => {
    console.log("uploadimage: ", uploadimage, imageField);
    if (uploadimage && uploadimage?.item) {
      setFileData(uploadimage.item.image);
    }
  }, [uploadimage, imageField]);

  useEffect(() => {
    console.log("deletedCompany: ", deletedCompany);
    if (deletedCompany && deletedCompany?.success) {
      setIsShowForm(false);
      setFormInputValues({
        _id: undefined,

        name: "",
        description: "",
        order: 0,
        img: "",
        isActive: true,
      });
      dispatch(actions.fetchCompanyList(filter));
    }
  }, [deletedCompany]);

  const onChangeIsActive = (row_value) => {
    console.log("row_value: ", filter);
    dispatch(
      actions.updateCompanyStatus({
        _id: row_value._id,
        isActive: row_value.isActive,
      })
    ).then((e) => {
      setTimeout(() => {
        dispatch(actions.fetchCompanyList(filter));
      }, 1000);
    });
  };

  // const reloadLocation = () => {
  //   window.location.reload();
  // };

  const editItem = (row_value) => {
    history.push("/company-edit/" + row_value._id);

    // console.log('row_value: ', row_value);
    // setIsShowForm(true);
    // setFormInputValues({
    //   _id: row_value._id,
    //   country: row_value.country.name,
    //   name: row_value.name,
    //   description: row_value.description,
    //   img: row_value.img.default,
    //   order: row_value.order,
    //   isActive: row_value.isActive,
    // });
    // setCountryListDropdownFilterData({ label: row_value.country.name, value: row_value.country._id })
    // setFileData(row_value.img);
    // setIsEditItem(true);
  };

  const deleteItem = (row_value) => {
    console.log("row_value: ", row_value);
    dispatch(actions.deleteCompany(row_value?._id));
  };

  const applyFilter = (values) => {
    // console.log(values.page)
    // return false
    // var tampCoinFilter = { ...filter };
    // console.log('val::11::1', values)

    // if (values?.dateRang) {
    //   tampCoinFilter.dateRange = values.dateRang;
    //   setDateRange(values.dateRang);
    // }

    // if (values?.type?._id) {
    //   tampCoinFilter.deliveryStatus = values.type._id;
    // } else {
    //   tampCoinFilter.deliveryStatus = null;
    // }

    // console.log('tampCoinFilter::2', tampCoinFilter, listLoading)
    let data = {};
    data.pagination = {};
    data.pagination.pageNo = values.page;

    // setFilter(tampCoinFilter);
    // setCount(count + 1);

    // console.log('tampCoinFilter::', tampCoinFilter, listLoading)
    if (!listLoading) {
      setSearchApply(true);
      dispatch(actions.fetchCompanyList(data));
    }
  };

  const DataTablePaginationAPICall = (values) => {
    setSearchApply(true);
    var tampFilter = { ...filter };
    console.log("val::11::1", values);
  
    // Assuming 'skip' and 'page' should also be integers
    tampFilter.skip = parseInt(values.skip, 10) || 0;  // Default to 0 if NaN
    tampFilter.page = parseInt(values.page, 10) || 1;  // Default to 1 if NaN
  
    if (values?.limit) {
      tampFilter.limit = parseInt(values.limit, 10) || 10;  // Default to 10 if NaN
    }
  
    console.log("tampFilter::2", tampFilter);
  
    setFilter(tampFilter);
  
    let data = {};
    data.pagination = {};
    data.pagination.pageNo = parseInt(values.page, 10) || 1;  // Default to 1 if NaN
    data.pagination.sortBy = "createdAt";
    data.pagination.limit = parseInt(values.limit, 10) || 10;  // Default to 10 if NaN
  
    if (!listLoading) {
      setSearchApply(true);
      dispatch(actions.fetchCompanyList(data));
    }
  };
  


  const exportButtonCSVAPICall = () => {
    console.log("exportButtonCSVAPICall");
    var tampCoinFilter = { ...filter };
    // dispatch(actions.fetchCoinCategoriesExport(tampCoinFilter));
  };

  return (
    <Card className="">
      <NotificationContainer />
      <CardHeader title="Company list">
        <CardHeaderToolbar>
          {helperFunc.isButtonAccess("company.company.add") && (
            <Button onClick={addItem}>Add Company</Button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <DeleteDialog
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        onDelete={handleDeleteConfirmation}
        item={itemToDelete} // Pass the item to delete
        name="Company" // You can customize the name if needed
      />
      <CardBody>
        {//  searchApply === true ?
        listLoading === false && totalCount === 0 ? (
          UIHelpers.dataTableNoData()
        ) : (
          <DataTable
            rows={rows ? rows : []}
            columns={allColumns}
            paginantionTotalAmountOfData={totalCount}
            DataTablePaginationAPICall={DataTablePaginationAPICall}
          />
        )
        // :

        // ''
        }
      </CardBody>
    </Card>
  );
}
